import { Select } from "../atoms/Select";
import { INDUSTRIES } from "../../constants/industries";

export function IndustrySelect({
  value,
  onChange,
  disabled,
}) {
  const handleChange = (e) => {
    onChange?.(e.target.value);
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      disabled={disabled}
    >
      <option value="">すべて</option>

      {INDUSTRIES.map((item) => (
        <option
          key={item}
          value={item}
        >
          {item}
        </option>
      ))}
    </Select>
  );
}